import { makeStyles } from "@material-ui/core";

export const LinkVariants = makeStyles((theme) => ({
    rulertel: {
        color: "#c70101",
        fontSize: "20px",
        fontWeight: 700,
        lineHeight: "20px",
        textDecoration: "none",
        pointer: "cursor",
    },
    emaillink: {
        color: "#c70101",
        fontSize: "17px",
        lineHeight: "20px",
        textDecoration: "none",
        pointer: "cursor",
    },
}));
